import React, { Component } from 'react';
import Uppy from '@uppy/core';
import { InputGroup, Label, LogoUpload } from 'prospect-path-components';
import AwsS3 from '@uppy/aws-s3';
import ms from 'ms';
import axios from 'axios';
import PropTypes from 'prop-types';

export default class ProductLogo extends Component {
  constructor(props) {
    super(props);

    this.fileInput = React.createRef();
    this.uploadArea = React.createRef();
    this.addFiles = this.addFiles.bind(this);
    this.uploadLogo = this.uploadLogo.bind(this);
    this.onFileClicked = this.onFileClicked.bind(this);
    this.handleDragIn = this.handleDragIn.bind(this);
    this.handleDragOut = this.handleDragOut.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.hasClearbitLogo = this.hasClearbitLogo.bind(this);
    this.useClearbitLogo = this.useClearbitLogo.bind(this);

    this.fileUploader = Uppy({
      autoProceed: true,
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: ['image/*'],
      },
    });

    this.fileUploader.on('upload-success', (file, response) => {
      const { location } = response.body;

      this.props.onChange(location);
    });
  }
  componentDidMount() {
    this.fileUploader.use(AwsS3, {
      limit: 1,
      timeout: ms('1 minute'),
      getUploadParameters: (file) => {
        const { type } = file;
        const uploadType = 'screenshot';

        return axios.post(
          `/api/teams/${this.props.teamId}/products/${this.props.productId}/uploads`,
          {
            type: uploadType,
            content_type: type,
          },
        )
          .then(response => ({
            method: 'PUT',
            url: response.data.uri,
          }));
      },
    });

    const uploadArea = this.uploadArea.current;
    uploadArea.addEventListener('dragenter', this.handleDragIn);
    uploadArea.addEventListener('dragleave', this.handleDragOut);
    uploadArea.addEventListener('dragover', this.handleDrag);
    uploadArea.addEventListener('drop', this.handleDrop);
  }
  componentWillUnmount() {
    const uploadArea = this.uploadArea.current;

    uploadArea.removeEventListener('dragenter', this.handleDragIn);
    uploadArea.removeEventListener('dragleave', this.handleDragOut);
    uploadArea.removeEventListener('dragover', this.handleDrag);
    uploadArea.removeEventListener('drop', this.handleDrop);
  }
  onFileClicked() {
    this.fileInput.current.click();
  }
  handleDragIn(e) {
    e.preventDefault();
  }
  handleDragOut(e) {
    e.preventDefault();
  }
  handleDrag(e) {
    e.preventDefault();
  }
  handleDrop(e) {
    e.preventDefault();
    const { files } = e.dataTransfer;

    if (files && files.length > 0) {
      this.addFiles(files);
    }
  }
  uploadLogo(event) {
    this.addFiles(event.target.files);
  }
  addFiles(files) {
    this.fileUploader.reset();
    [...files].forEach(file => this.fileUploader.addFile({
      name: file.name,
      type: file.type,
      data: file,
    }));
  }
  hasClearbitLogo() {
    if (this.props.product && this.props.product.clearbit_logo) {
      return true;
    }

    if (this.props.vendor && this.props.vendor.clearbit_logo) {
      return true;
    }

    return false;
  }
  useClearbitLogo() {
    if (this.props.product && this.props.product.clearbit_logo) {
      this.props.onChange(this.props.product.clearbit_logo);
    }
    if (this.props.vendor && this.props.vendor.clearbit_logo) {
      this.props.onChange(this.props.vendor.clearbit_logo);
    }
  }
  render() {
    return (
      <InputGroup>
        <input
          ref={this.fileInput}
          type="file"
          accept="image/*"
          onChange={this.uploadLogo}
          style={{ display: 'none' }}
        />

        <Label>Product Logo</Label>
        <div ref={this.uploadArea}>
          { this.hasClearbitLogo() ?
            (<LogoUpload
              onClearbitClicked={this.useClearbitLogo}
              previewImageUrl={this.props.previewImageUrl}
              onFileClicked={this.onFileClicked}
              disabled={this.props.disabled}
            />) :
            (<LogoUpload
              previewImageUrl={this.props.previewImageUrl}
              onFileClicked={this.onFileClicked}
              disabled={this.props.disabled}
            />) }
        </div>
      </InputGroup>
    );
  }
}

ProductLogo.defaultProps = {
  previewImageUrl: null,
  disabled: false,
};

ProductLogo.propTypes = {
  teamId: PropTypes.number.isRequired,
  productId: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  previewImageUrl: PropTypes.string,
  product: PropTypes.object.isRequired,
  vendor: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};
